import React from "react";
import {Box} from "@cjdev-internal/visual-stack";
import LoadingAnimation from "@cjdev-internal/visual-stack/lib/components/LoadingAnimation";
import "./media-tracker-page-content.css"
import {ModalMountPoint} from "@cjdev-internal/visual-stack-redux/lib/components/Modal";
import {AlertMountPoint} from "@cjdev-internal/visual-stack-redux/lib/components/Alert";

const MediaTrackerPageContent = (CampaignsDataTable,
                                 Message) => {
    return function MediaTrackerPageContent({
                                                companiesName,
                                                getPlacementDataHandler,
                                            }) {

        let data = getPlacementDataHandler.data;
        let loading = getPlacementDataHandler.loading;

        return (
            <div>
                <ModalMountPoint/>
                <AlertMountPoint/>
                {
                    (loading === true || companiesName === undefined) ?
                        (<Box direction="row" justify="center" className="loadingAnimationBox">
                            <LoadingAnimation/>
                        </Box>) : (
                            (data === undefined || data.getPlacementData === null) ?
                                <Message companiesName={companiesName}/> :
                                <CampaignsDataTable values={data.getPlacementData}/>
                        )
                }
            </div>
        );
    }
};

export default MediaTrackerPageContent;
